import cx from 'classnames';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import './MobileButton.sass';

export const MobileButton = ({icon, title, onClick, active, dataQaId}) => (
  <div>
    <Button
      onClick={onClick}
      id="navBottom"
      className={cx('card_editor__mobile__button', {
        'card_editor__mobile__button--active': !!active,
      })}
      variant="secondary"
      size="medium"
      data-qa-id={dataQaId}
    >
      {icon}
    </Button>
    <Typography variant="paragraph3" className="card_editor__mobile__button__title">
      {title}
    </Typography>
  </div>
);
